import React from 'react'
import classes from './styles.module.scss'
import { Link } from 'react-router-dom'

interface IProps {
    color: string
    percent: number
    title: string | number,
    description: string
    status: string
}
export function CircleProcess({ color = "blue", percent, title, description, status }: IProps) {

    const percentToDeg = (percent / 100) * 360
    return (
        <div className={classes.wrapper}>
            <div className={classes.circle}
                style={{
                    background: `conic-gradient(${color} ${percentToDeg}deg, #f7f7f7 0deg)`
                }}
                data-percent={percent}>
                <div className={classes.percent}>
                    {percent}%
                </div>
            </div>
            <div className={classes.footer}>
                <div className={classes.title}>
                    {title}
                </div>
                <Link to={`/stat-by-services/${status}`} className={classes.description}>
                    {description}
                </Link>
            </div>
        </div>
    )
}
